<template>
  <div class="container welcomeScreen">
    <TheHeader mode="welcome" />
    <div class="welcomeScreen__info">
      <WelcomeInfoCard
        :greeting="greeting"
        :image-url="imageUrl"
        :text="text"
      />
    </div>
    <div class="welcomeScreen__continue">
      <AppButton
        :text="$t('screens.welcome.continue')"
        class="continue"
        @click="
          $router.push({
            name: this.nextStep,
            params: {
              locale: this.$i18n.locale,
            },
            query: {
              ...this.$route.query,
            },
          })
        "
      />
    </div>
  </div>
</template>

<script>
import TheHeader from "@/components/common/TheHeader";
import WelcomeInfoCard from "@/components/welcome/WelcomeInfoCard";
import AppButton from "@/components/UI/AppButton";
import { mapGetters } from "vuex";
import { getFullName } from "@/helpers";

export default {
  name: "WelcomeScreen",
  components: { AppButton, WelcomeInfoCard, TheHeader },
  computed: {
    ...mapGetters({
      reservation: "booking/reservation",
    }),
    greeting() {
      return this.reservation?.["welcome"]?.["greeting"];
    },
    imageUrl() {
      return this.reservation?.["welcome"]?.image;
    },
    text() {
      return this.reservation?.["welcome"]?.text;
    },
    fullName() {
      return getFullName(this.$t, this.reservation["reservation"]["profiles"]);
    },
    nextStep() {
      return "agreementsScreen";
    },
  },
};
</script>
<style lang="scss">
.welcomeScreen__info {
  margin-bottom: 20px;
}

.welcomeScreen__continue {
  margin-bottom: 20px;
  width: 100%;
}

@include media-breakpoint-up(sm) {
  .welcomeScreen__info {
    margin-bottom: 30px;
  }
  .welcomeScreen__continue {
    max-width: 420px;
    margin: 0 auto 30px;
  }
}
</style>
